<ng-container *transloco="let t">
  @if (user(); as currentUser) {
    @if (compact()) {
      <!-- Compact layout for mobile header -->
      <div class="flex items-center gap-2">
        <span class="text-sm font-medium text-surface-700 dark:text-surface-100">
          {{ currentUser.fullName }}
        </span>
        <p-button
          type="button"
          icon="pi pi-sign-out"
          [label]="t('layout.default.user.logout')"
          severity="secondary"
          size="small"
          (onClick)="onLogout()"
        />
      </div>
    } @else {
      <!-- Full layout for sidebar -->
      <div class="mt-auto border-t border-surface-200 pt-4 dark:border-surface-800">
        <div class="flex items-center gap-3 rounded-lg bg-surface-100 p-3 dark:bg-surface-800/50">
          <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 text-sm font-semibold text-white">
            {{ currentUser.fullName?.charAt(0) || '?' }}
          </div>
          <div class="flex-1 min-w-0">
            <div class="truncate text-sm font-semibold text-surface-900 dark:text-surface-0">
              {{ currentUser.fullName }}
            </div>
            <div class="truncate text-xs text-surface-500 dark:text-surface-400">
              {{ currentUser.email }}
            </div>
          </div>
          <p-button
            type="button"
            icon="pi pi-sign-out"
            [text]="true"
            [rounded]="true"
            severity="secondary"
            size="small"
            [pTooltip]="t('layout.default.user.logout')"
            tooltipPosition="top"
            (onClick)="onLogout()"
          />
        </div>
      </div>
    }
  }
</ng-container>
